import React from "react";
import "./Loader.css";

export const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="coffee">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
